/** Тип транзакции (доход/расход). */
export enum TransactionType {
    /** Доход */
    Income = 1,

    /** Расход */
    Expense = -1
}
